(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const money = (cents) => {
    const n = (Number(cents) / 100).toFixed(2);
    const cur = window.Shopify?.currency?.active || 'USD';
    if (cur === 'USD') return '$' + n;
    try {
      return (Number(cents) / 100).toLocaleString(undefined, { style: 'currency', currency: cur });
    } catch {
      return '$' + n;
    }
  };

  const freeShip = Number(document.documentElement.dataset.freeShip || 40) * 100;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function renderCart(cart) {
    const countEl = $('#hs-cart-count');
    const itemsEl = $('#hs-cart-items');
    const subEl = $('#hs-cart-subtotal');
    const bar = $('#hs-cart-bar');
    const msg = $('#hs-cart-ship-msg');
    const n = cart.item_count || 0;
    if (countEl) {
      countEl.textContent = n;
      countEl.classList.toggle('is-on', n > 0);
    }
    if (subEl) subEl.textContent = money(cart.total_price);
    const pct = Math.min(100, (cart.total_price / freeShip) * 100);
    if (bar) bar.style.width = pct + '%';
    if (msg) {
      if (!n) msg.textContent = 'Free shipping over $' + (freeShip / 100);
      else if (cart.items.some((item) => item.selling_plan_allocation)) msg.textContent = 'Subscription shipping shown at checkout';
      else if (cart.total_price >= freeShip) msg.textContent = 'Free shipping unlocked';
      else msg.textContent = money(freeShip - cart.total_price) + ' away from free shipping';
    }
    if (!itemsEl) return;
    if (!n) {
      itemsEl.innerHTML = '<div class="hs-drawer__empty">Your tin is empty.<br>Shop a strip to get started.</div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="hs-drawer__line" data-key="${item.key}">
        <img src="${item.image ? item.image.replace(/(\.[^.]*)$/, '_120x$1') : ''}" alt="${item.product_title}">
        <div style="flex:1;min-width:0">
          <div style="font-family:'New Kansas',serif;font-size:15px">${item.product_title}</div>
          <div style="font-size:11px;color:#5F7268">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="hs-drawer__qty">
            <button type="button" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
            <span style="font-family:'Monument Extended',sans-serif;font-size:12px">${item.quantity}</span>
            <button type="button" data-qty="${item.quantity + 1}" aria-label="Increase" style="background:#EEE829">+</button>
            <button type="button" data-qty="0" style="margin-left:auto;background:none;border:none;text-decoration:underline;font-size:11px;color:#5F7268;width:auto;height:auto">Remove</button>
          </div>
        </div>
        <span style="font-family:'Monument Extended',sans-serif;font-size:13px">${money(item.final_line_price)}</span>
      </div>
    `).join('');
  }

  async function changeQty(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  async function addToCart(id, qty = 1, sellingPlan) {
    const item = { id, quantity: qty };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(err.description || 'Could not add to cart');
      return;
    }
    const cart = await getCart();
    renderCart(cart);
    openCart();
  }

  function openCart() {
    $('#hs-cart')?.classList.add('is-open');
    document.body.classList.add('drawer-open');
  }
  function closeCart() {
    $('#hs-cart')?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-open-cart]');
    if (openBtn) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-close-cart]')) { closeCart(); return; }

    const qtyBtn = e.target.closest('#hs-cart-items [data-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('[data-key]');
      changeQty(line.dataset.key, Number(qtyBtn.dataset.qty));
    }

    const addBtn = e.target.closest('[data-add]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn.dataset.add, Number(addBtn.dataset.qty || 1));
    }

    const acc = e.target.closest('.hs-acc__btn');
    if (acc) {
      const item = acc.parentElement;
      const on = !item.classList.contains('is-open');
      item.classList.toggle('is-open', on);
      acc.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    const menu = e.target.closest('[data-menu-toggle]');
    if (menu) $('#hs-nav')?.classList.toggle('is-open');

    const tab = e.target.closest('[data-shop-tab]');
    if (tab) {
      $$('[data-shop-tab]').forEach((t) => t.classList.toggle('is-on', t === tab));
      const fam = tab.dataset.shopTab;
      $$('#shop [data-fam]').forEach((card) => {
        const on = fam === 'all' || card.dataset.fam === fam;
        card.style.opacity = on ? '1' : '0.28';
        card.style.filter = on ? 'none' : 'grayscale(0.35)';
      });
    }

    const vp = e.target.closest('[data-vp-tab]');
    if (vp) {
      $$('[data-vp-tab]').forEach((t) => t.classList.toggle('is-on', t === vp));
      const name = vp.dataset.vpTab;
      $$('[data-vp-panel]').forEach((p) => { p.hidden = p.dataset.vpPanel !== name; });
      const row = $('[data-vp-videos]');
      if (row) {
        $$('[data-vp-vid]', row)
          .sort((a, b) => Number(b.dataset.vpVid === name) - Number(a.dataset.vpVid === name))
          .forEach((c) => row.appendChild(c));
      }
    }

    const clean = e.target.closest('[data-clean], [data-clean-dot]');
    if (clean) {
      const i = clean.dataset.clean || clean.dataset.cleanDot;
      const source = $(`[data-clean="${i}"]`) || clean;
      $$('[data-clean]').forEach((c) => {
        const on = c.dataset.clean === i;
        c.classList.toggle('is-on', on);
        const cue = c.querySelector('[data-clean-cue]');
        if (cue) {
          const onText = c.dataset.cueOn || 'Showing this';
          const offText = c.dataset.cueOff || 'See it';
          cue.textContent = on ? onText : offText;
        }
      });
      $$('[data-clean-dot]').forEach((d) => d.classList.toggle('is-on', d.dataset.cleanDot === i));
      const view = $('[data-clean-view]');
      if (view) {
        if (source.dataset.grad) view.style.background = source.dataset.grad;
        const cap = view.querySelector('[data-clean-caption]');
        if (cap && source.dataset.caption) cap.textContent = source.dataset.caption;
        const img = view.querySelector('[data-clean-img]');
        if (img && source.dataset.img) {
          img.src = source.dataset.img;
          img.alt = source.dataset.caption || '';
          img.hidden = false;
        }
      }
    }

    if (e.target.closest('[data-close-pop]')) {
      $('#hs-pop')?.classList.remove('is-open');
      try { localStorage.setItem('hs-pop', '1'); } catch (_) {}
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const id = form.querySelector('[name="id"]')?.value;
    const qty = Number(form.querySelector('[name="quantity"]')?.value || 1);
    const chosen = form.querySelector('[data-pdp-opt].is-on');
    const plan = chosen ? chosen.dataset.plan : form.querySelector('[name="selling_plan"]')?.value;
    if (id) addToCart(id, qty, plan);
  }, true);

  // PDP buy box
  $$('[data-pdp-buy]').forEach((box) => {
    const cta = box.querySelector('[data-pdp-cta]');
    const qtyInput = box.querySelector('[data-pdp-qty]');
    const planInput = box.querySelector('[data-pdp-plan]');
    function sync(opt) {
      if (!opt) return;
      $$('[data-pdp-opt]', box).forEach((o) => {
        o.classList.toggle('is-on', o === opt);
        const icon = o.querySelector('.msr');
        if (icon && (icon.textContent || '').includes('radio')) {
          icon.textContent = o === opt ? 'radio_button_checked' : 'radio_button_unchecked';
        }
      });
      if (qtyInput) qtyInput.value = opt.dataset.qty || '1';
      if (planInput) planInput.value = opt.dataset.plan || '';
      const cents = Number(opt.dataset.cents || 0);
      if (cta && cents) cta.textContent = 'Add to cart — ' + money(cents);
      const stickyPrice = $('#hs-pdp-sticky [data-pdp-sticky-price]');
      const stickyOffer = $('#hs-pdp-sticky [data-pdp-sticky-offer]');
      if (stickyPrice && cents) stickyPrice.textContent = money(cents);
      if (stickyOffer) {
        const isSub = Boolean(opt.dataset.plan);
        stickyOffer.textContent = isSub
          ? 'Save ' + (opt.dataset.discount || '20') + '% — ' + (opt.dataset.label || 'Subscribe')
          : (opt.dataset.label || 'Add to cart');
      }
    }
    const first = box.querySelector('[data-pdp-opts-sub] [data-pdp-opt].is-on') || box.querySelector('[data-pdp-opt].is-on');
    sync(first);
    box.addEventListener('click', (e) => {
      const mode = e.target.closest('[data-pdp-mode]');
      if (mode) {
        $$('[data-pdp-mode]', box).forEach((t) => t.classList.toggle('is-on', t === mode));
        const isSub = mode.dataset.pdpMode === 'sub';
        const once = box.querySelector('[data-pdp-opts-once]');
        const sub = box.querySelector('[data-pdp-opts-sub]');
        if (once) once.hidden = isSub;
        if (sub) sub.hidden = !isSub;
        const first = (isSub ? sub : once)?.querySelector('[data-pdp-opt]');
        sync(first);
        return;
      }
      const opt = e.target.closest('[data-pdp-opt]');
      if (opt) sync(opt);
    });
  });

  const pdpThumbs = $$('[data-pdp-thumb]');
  pdpThumbs.forEach((btn, index) => {
    btn.classList.toggle('is-active', index === 0);
    btn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
    btn.addEventListener('click', () => {
      const img = document.querySelector('.hs-pdp__hero-img');
      if (img && btn.dataset.pdpThumb) {
      img.removeAttribute('srcset');
      img.src = btn.dataset.pdpThumb;
      pdpThumbs.forEach((thumb) => {
        const active = thumb === btn;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    });
  });

  document.addEventListener('click', (e) => {
    const factsEl = $('#hs-facts');
    if (e.target.closest('[data-open-facts]') && factsEl) factsEl.hidden = false;
    if (e.target.closest('[data-close-facts]') && factsEl) factsEl.hidden = true;
  });

  // Collection filters
  const grid = $('[data-coll-grid]');
  if (grid) {
    let benefit = 'all';
    let flavor = '';
    function apply() {
      const cards = $$('.hs-pcard', grid);
      let n = 0;
      cards.forEach((c) => {
        const okB = benefit === 'all' || c.dataset.benefit === benefit;
        const okF = !flavor || c.dataset.flavor === flavor;
        const on = okB && okF;
        c.style.display = on ? '' : 'none';
        if (on) n += 1;
      });
      const count = $('[data-coll-count]');
      if (count) count.textContent = n + (n === 1 ? ' strip' : ' strips');
      const empty = $('[data-coll-empty]');
      if (empty) empty.hidden = n > 0;
      $$('[data-coll-pill]').forEach((b) => {
        const on = b.dataset.collPill === benefit || (benefit === 'all' && b.dataset.collPill === 'all');
        b.classList.toggle('is-on', on);
        const icon = b.querySelector('.msr');
        if (icon && b.dataset.collPill !== 'all') icon.textContent = (benefit === b.dataset.collPill) ? 'check_box' : 'check_box_outline_blank';
      });
      $$('[data-coll-flavor]').forEach((b) => {
        const icon = b.querySelector('.msr');
        if (icon) icon.textContent = flavor === b.dataset.collFlavor ? 'check_box' : 'check_box_outline_blank';
      });
    }
    document.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-coll-pill]');
      if (pill && (grid.contains(pill) || pill.closest('[data-coll-pills]'))) {
        benefit = pill.dataset.collPill || 'all';
        apply();
      }
      const fl = e.target.closest('[data-coll-flavor]');
      if (fl) {
        flavor = flavor === fl.dataset.collFlavor ? '' : fl.dataset.collFlavor;
        apply();
      }
      if (e.target.closest('[data-coll-clear]')) {
        benefit = 'all';
        flavor = '';
        apply();
      }
    });
  }

  const sticky = $('#hs-pdp-sticky');
  if (sticky) {
    const buy = document.querySelector('[data-pdp-buy]');
    if (buy && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        sticky.hidden = entries.some((entry) => entry.isIntersecting);
      }, { threshold: 0.12 });
      io.observe(buy);
    } else {
      sticky.hidden = true;
    }
    sticky.addEventListener('click', (e) => {
      if (!e.target.closest('[data-pdp-sticky]')) return;
      document.querySelector('[data-product-form]')?.requestSubmit();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeCart();
    const factsEl = $('#hs-facts');
    if (factsEl) factsEl.hidden = true;
    $('#hs-pop')?.classList.remove('is-open');
  });

  getCart().then(renderCart).catch(() => {});

  if (!localStorage.getItem('hs-pop')) {
    setTimeout(() => $('#hs-pop')?.classList.add('is-open'), 6000);
  }

  function initUgcVideos() {
    const videos = $$('[data-hs-ugc]');
    if (!videos.length) return;
    const reduced = document.documentElement.classList.contains('hs-reduced') || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection?.saveData;
    const visible = new Set();
    const arm = (video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.volume = 0;
    };
    videos.forEach(arm);
    if (reduced || saveData || !('IntersectionObserver' in window)) {
      videos.forEach((video) => { video.controls = true; });
      return;
    }

    const play = (video) => {
      const wrap = video.closest('.hs-ugc');
      const p = video.play();
      if (p && p.then) {
        p.then(() => {
          wrap?.classList.add('is-live');
          window.setTimeout(() => wrap?.classList.add('is-quiet'), 1800);
        }).catch(() => { video.controls = true; });
      }
    };
    const pause = (video) => { if (!video.paused) video.pause(); };
    const canPlay = (video) => {
      const rect = video.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && !video.closest('[hidden], [aria-hidden="true"], [inert]');
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
        if (isIntersecting && intersectionRatio >= 0.35 && canPlay(target)) {
          visible.add(target);
          if (!document.hidden) play(target);
        } else {
          visible.delete(target);
          pause(target);
        }
      });
    }, { threshold: 0.35, rootMargin: '0px' });
    videos.forEach((video) => io.observe(video));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach(pause);
      else visible.forEach((video) => { if (canPlay(video)) play(video); });
    });
    videos.forEach((video) => {
      video.addEventListener('click', () => {
        if (video.controls) return;
        if (video.paused) play(video);
        else pause(video);
      });
    });
  }

  function initType() {
    const reduced = document.documentElement.classList.contains('hs-reduced');
    const heads = $$('.hs-h2, .hs-kicker, .hs-quote').filter((el) => !el.closest('.hs-hero, .hs-motion'));

    const play = (el) => {
      el.classList.add('is-typed');
    };

    if (reduced || !('IntersectionObserver' in window)) {
      heads.forEach(play);
      document.documentElement.classList.add('hs-type-done');
      return;
    }

    heads.forEach((el) => {
      el.classList.add('hs-type');
      if (el.matches('.hs-h2') && !el.querySelector('.hs-type__in')) {
        const inner = document.createElement('span');
        inner.className = 'hs-type__in';
        inner.append(...el.childNodes);
        el.appendChild(inner);
      }
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        play(target);
        io.unobserve(target);
      });
    }, { threshold: 0.4, rootMargin: '0px 0px -12% 0px' });

    heads.forEach((el) => io.observe(el));
  }

  function pauseOffscreenMotion() {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        target.style.animationPlayState = isIntersecting ? 'running' : 'paused';
      });
    }, { rootMargin: '12% 0px' });
    $$('[data-hs-marquee], [data-hs-marquee-y], .hs-announce__track, .hs-hero__bar-track, .hs-pdp-ugc__row').forEach((el) => io.observe(el));
  }

  initUgcVideos();
  initType();
  pauseOffscreenMotion();

  // Quiz
  const quiz = $('#hs-quiz-app');
  if (quiz) {
    const questions = [
      { title: 'What brings you here?', sub: 'Pick the one that matters most right now.', opts: [
        { label: 'More energy and focus through the day', chip: 'Energy & focus', ico: 'bolt', w: { b12: 3, multi: 1 } },
        { label: 'Falling asleep faster, waking up clearer', chip: 'Better sleep', ico: 'bedtime', w: { mel: 3 } },
        { label: 'Stronger hair, skin and nails', chip: 'Hair, skin, nails', ico: 'auto_awesome', w: { bio: 3 } },
        { label: 'Covering my everyday nutrition basics', chip: 'Daily basics', ico: 'nutrition', w: { multi: 3, d3: 1 } },
        { label: 'Honestly? A bit of everything', chip: 'A bit of everything', ico: 'all_inclusive', w: { multi: 2 }, all: true }
      ]},
      { title: 'How does 3pm usually feel?', sub: 'Be honest. The strip does not judge.', opts: [
        { label: 'I am on my third coffee by then', chip: 'Third coffee', ico: 'coffee', w: { b12: 2 } },
        { label: 'I crash right after lunch', chip: 'Afternoon crash', ico: 'battery_2_bar', w: { b12: 2, multi: 1 } },
        { label: 'Fine until the evening, then I fade', chip: 'Evening fade', ico: 'wb_twilight', w: { d3: 1, mel: 1 } },
        { label: 'Wired all day, tired the second I sit down', chip: 'Wired then tired', ico: 'bolt', w: { mel: 1, b12: 1 } }
      ]},
      { title: 'And how is your sleep?', sub: 'The 11pm-to-7am report.', opts: [
        { label: 'Out in minutes, most nights', chip: 'Sleeps easy', ico: 'sentiment_satisfied', w: { d3: 1 } },
        { label: 'It takes me 30+ minutes to fall asleep', chip: 'Slow to sleep', ico: 'hourglass_empty', w: { mel: 2 } },
        { label: 'I wake up during the night and start over', chip: 'Night waking', ico: 'nights_stay', w: { mel: 2 } },
        { label: 'Eight hours and still tired in the morning', chip: 'Tired mornings', ico: 'wb_cloudy', w: { b12: 1, d3: 1, multi: 1 } }
      ]},
      { title: 'Which of these sounds like you?', sub: 'Diet and lifestyle, roughly.', opts: [
        { label: 'Vegan or vegetarian — mostly plants', chip: 'Plant-based', ico: 'eco', w: { b12: 2, multi: 1 } },
        { label: 'Indoors most of the day, screens included', chip: 'Indoor days', ico: 'desktop_windows', w: { d3: 2 } },
        { label: 'Heat, bleach or braids on my hair regularly', chip: 'Hair on a schedule', ico: 'content_cut', w: { bio: 2 } },
        { label: 'Balanced-ish, nothing extreme', chip: 'Balanced-ish', ico: 'spa', w: { multi: 1 } }
      ]},
      { title: 'What does your supplement shelf look like today?', sub: 'Last one.', opts: [
        { label: 'Empty — I am starting fresh', chip: 'Starting fresh', ico: 'inventory_2', w: { multi: 2 } },
        { label: 'One or two things I mostly remember', chip: 'Mostly remember', ico: 'check_box', w: {} },
        { label: 'A graveyard of half-finished bottles', chip: 'Bottle graveyard', ico: 'delete', w: { multi: 2 } },
        { label: 'I avoid it all because I hate swallowing pills', chip: 'Hates pills', ico: 'block', w: { multi: 1 } }
      ]}
    ];
    const TIE = ['multi', 'b12', 'mel', 'bio', 'd3'];
    let catalog = {};
    try { catalog = JSON.parse($('#hs-quiz-catalog')?.textContent || '{}'); } catch (e) { catalog = {}; }
    let step = -1;
    const answers = [null, null, null, null, null];
    let gateName = '';
    let sentTo = '';
    let locked = false;
    let paintedStep = null;
    const introEl = $('#hs-quiz-intro');
    const qEl = $('#hs-quiz-q');
    const rEl = $('#hs-quiz-r');
    const gateEl = $('#hs-quiz-gate');
    const nlForm = $('#hs-quiz-nl') || quiz.querySelector('.hs-quiz-gate__form');
    if (nlForm) nlForm.noValidate = true;

    function esc(s) {
      return String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
    function score() {
      const s = { b12: 0, mel: 0, bio: 0, d3: 0, multi: 0 };
      let halo = false;
      answers.forEach((i, qi) => {
        const o = questions[qi].opts[i];
        if (!o) return;
        if (o.all) halo = true;
        Object.entries(o.w || {}).forEach(([k, v]) => { s[k] += v; });
      });
      const ranked = Object.keys(s).sort((a, b) => (s[b] - s[a]) || (TIE.indexOf(a) - TIE.indexOf(b)));
      return { ranked, halo, s };
    }
    function recap() {
      return answers.map((i, qi) => questions[qi].opts[i]?.chip || questions[qi].opts[i]?.label).filter(Boolean);
    }
    function pickBundle(top, second, halo) {
      if (halo) return catalog.halo;
      const pair = [top, second].sort().join('+');
      if (pair === 'b12+mel') return catalog.rest;
      if (pair === 'bio+multi') return catalog.glow;
      if (pair === 'd3+multi') return catalog.duo;
      if (top === 'bio' || second === 'bio') return catalog.glow;
      return catalog.duo || catalog.halo;
    }
    function lockBody(on) {
      document.body.style.overflow = on ? 'hidden' : '';
    }
    function hideAll() {
      if (introEl) introEl.hidden = true;
      if (qEl) qEl.hidden = true;
      if (rEl) rEl.hidden = true;
      if (gateEl) gateEl.hidden = true;
      lockBody(false);
    }
    function bump(el) {
      if (!el) return;
      el.classList.remove('is-in');
      void el.offsetWidth;
      el.classList.add('is-in');
    }
    function showResults() {
      hideAll();
      rEl.hidden = false;
      bump(rEl);
      const { ranked, halo, s } = score();
      const topKey = ranked[0];
      const secondKey = ranked[1];
      const top = catalog[topKey] || catalog.b12;
      const second = catalog[secondKey] || catalog.multi;
      const bundle = pickBundle(topKey, secondKey, halo);
      const close = (s[topKey] || 0) - (s[secondKey] || 0) <= 1;
      const greet = gateName.trim() ? esc(gateName.trim()) + '’s ' : 'Your ';
      const art = top.img
        ? `<img src="${esc(top.img)}" alt="${esc(top.name)}" width="420" height="420">`
        : `<span class="msr" style="color:${esc(top.fg || '#fff')}">${esc(top.icon || 'bolt')}</span>`;
      const atc = top.vid
        ? `<button type="button" class="hs-btn hs-btn--fluoro" data-add="${esc(top.vid)}">Add my match</button>`
        : `<a class="hs-btn hs-btn--fluoro" href="${esc(top.url)}">Shop my match →</a>`;
      const how = Array.isArray(top.how) && top.how.length === 3
        ? top.how
        : ['Peel one strip', 'Place it on your tongue', 'Ten seconds. Done.'];
      rEl.innerHTML = `
        <div class="hs-quiz-res">
          <div class="hs-quiz-res__intro">
            <div class="hs-kicker">Your results</div>
            <h1>${greet}stack, <span class="hs-hl">decided.</span></h1>
            ${sentTo ? `<div class="hs-quiz-res__mail"><span class="msr">mark_email_read</span>A copy is on its way to <strong>${esc(sentTo)}</strong></div>` : ''}
            <div class="hs-quiz-res__chips">${recap().map((c) => `<span>${esc(c)}</span>`).join('')}</div>
          </div>
          <div class="hs-quiz-match">
            <div class="hs-quiz-match__art" style="background:${esc(top.color || '#E0524D')}">${art}<span class="hs-quiz-match__flag">Your match</span></div>
            <div class="hs-quiz-match__copy">
              <div class="hs-quiz-match__fam">${esc(top.fam || '')}${top.flavor ? ' · ' + esc(top.flavor) : ''}</div>
              <div class="hs-quiz-match__name">${esc(top.name)}</div>
              <p>${esc(top.blurb || '')}</p>
              ${top.claim ? `<p class="hs-quiz-claim">${esc(top.claim)}</p>` : ''}
              <div class="hs-quiz-match__price"><strong>${esc(top.price || '$27.99')}</strong><span>/ month with Subscribe &amp; Save</span><span class="was">${esc(top.compare || '$34.99')}</span></div>
              <div class="hs-quiz-match__ctas">
                ${atc}
                <a class="hs-btn hs-btn--ink" href="${esc(top.url)}">View product</a>
                <button type="button" id="hs-quiz-restart" class="hs-quiz-restart">Retake quiz</button>
              </div>
            </div>
          </div>
          <div class="hs-quiz-why">
            <div>
              <span class="hs-quiz-match__fam">Why this strip</span>
              <p>${esc(top.why || '')}</p>
            </div>
            <ol class="hs-quiz-how">
              <li><b>01</b>${esc(how[0])}</li>
              <li><b>02</b>${esc(how[1])}</li>
              <li><b>03</b>${esc(how[2])}</li>
            </ol>
          </div>
          <div class="hs-quiz-side">
            <div class="hs-quiz-runner">
              <div class="hs-quiz-match__fam">${close ? 'Also a strong fit' : 'Runner-up'}</div>
              <div class="hs-quiz-runner__row">
                <div class="hs-quiz-runner__ico" style="background:${esc(second.color || '#041E16')}"><span class="msr" style="color:${esc(second.fg || '#fff')}">${esc(second.icon || 'auto_awesome')}</span></div>
                <div>
                  <strong>${esc(second.name)}</strong>
                  <small>${esc(second.fam || '')} · ${esc(second.price || '$27.99')}/mo</small>
                </div>
              </div>
              <p>${esc(second.short || '')}</p>
              ${second.vid ? `<button type="button" class="hs-btn hs-btn--ink" data-add="${esc(second.vid)}" style="align-self:flex-start;padding:10px 16px;font-size:9.5px">Add runner-up</button>` : ''}
              <a href="${esc(second.url)}">View ${esc(second.name)} →</a>
            </div>
            ${bundle ? `<div class="hs-quiz-bundle">
              <div class="hs-quiz-bundle__top"><span>Better together</span><em>${esc(bundle.save || '')}</em></div>
              <strong>${esc(bundle.name)}</strong>
              <p>${esc(bundle.desc || '')}</p>
              <div class="hs-quiz-match__price"><strong>${esc(bundle.price || '')}</strong><span class="was">${esc(bundle.compare || '')}</span></div>
              <a class="hs-btn hs-btn--fluoro" href="${esc(bundle.url)}">Shop the bundle</a>
            </div>` : ''}
          </div>
          <div class="hs-quiz-code">
            <span class="msr">sell</span>
            <div><b>HOLYQUIZ10</b><span>10% off your first order — applied at checkout with this code.</span></div>
            <button type="button" id="hs-quiz-copy" class="hs-btn hs-btn--ink">Copy code</button>
          </div>
          <div class="hs-quiz-trust">
            <span><span class="msr">verified_user</span>30-day guarantee</span>
            <span><span class="msr">science</span>Third-party tested</span>
            <span><span class="msr">eco</span>Vegan · no added sugar</span>
          </div>
        </div>
      `;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      $('#hs-quiz-restart')?.addEventListener('click', () => {
        step = -1; answers.fill(null); gateName = ''; sentTo = ''; locked = false; paintedStep = null;
        try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
        if ($('#hs-gate-name')) $('#hs-gate-name').value = '';
        if ($('#hs-gate-email')) $('#hs-gate-email').value = '';
        const err = $('#hs-gate-error'); if (err) { err.hidden = true; err.textContent = ''; }
        paint();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      $('#hs-quiz-copy')?.addEventListener('click', async (e) => {
        try { await navigator.clipboard.writeText('HOLYQUIZ10'); e.currentTarget.textContent = 'Copied'; }
        catch { e.currentTarget.textContent = 'HOLYQUIZ10'; }
      });
    }
    function openGate() {
      hideAll();
      if (!gateEl) { showResults(); return; }
      gateEl.hidden = false;
      lockBody(true);
      window.setTimeout(() => $('#hs-gate-name')?.focus(), 40);
    }
    const STORE_KEY = 'hs-quiz-v1';
    function persist() {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({ step, answers }));
      } catch (e) {}
    }
    function pick(i) {
      if (locked || step < 0 || step >= 5) return;
      if (i < 0 || i >= questions[step].opts.length) return;
      locked = true;
      answers[step] = i;
      persist();
      paint(false);
      window.setTimeout(() => { step += 1; locked = false; persist(); paint(); }, 220);
    }
    function paint(animate) {
      if (step < 0) {
        hideAll();
        if (introEl) { introEl.hidden = false; if (animate !== false) bump(introEl); }
        persist();
        return;
      }
      if (step >= 5) { persist(); openGate(); return; }
      const stepChanged = paintedStep !== step;
      if (qEl.hidden) {
        hideAll();
        qEl.hidden = false;
      }
      if (animate !== false && stepChanged) bump(qEl);
      paintedStep = step;
      const q = questions[step];
      $('#hs-quiz-num').textContent = `${step + 1} / 5`;
      const bar = $('#hs-quiz-bar');
      if (bar) bar.style.width = (((step + 1) / 5) * 100) + '%';
      bar?.parentElement?.setAttribute('aria-valuenow', String(step + 1));
      $('#hs-quiz-title').textContent = q.title;
      $('#hs-quiz-sub').textContent = q.sub;
      $('#hs-quiz-opts').innerHTML = q.opts.map((o, i) => {
        const on = answers[step] === i;
        return `<button type="button" class="hs-quiz__opt${on ? ' is-on' : ''}" data-i="${i}" role="option" aria-selected="${on ? 'true' : 'false'}"><span class="msr">${esc(o.ico || 'radio_button_unchecked')}</span><span>${esc(o.label)}</span></button>`;
      }).join('');
      const back = $('#hs-quiz-back');
      if (back) back.style.visibility = step ? 'visible' : 'hidden';
    }
    $('#hs-quiz-start')?.addEventListener('click', () => { step = 0; persist(); paint(); });
    quiz.addEventListener('click', (e) => {
      if (e.target.closest('#hs-quiz-back')) {
        if (locked) return;
        step = Math.max(0, step - 1);
        persist();
        paint();
        return;
      }
      const opt = e.target.closest('[data-i]');
      if (!opt) return;
      pick(Number(opt.dataset.i));
    });
    nlForm?.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = ($('#hs-gate-email')?.value || '').trim();
      const err = $('#hs-gate-error');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        if (err) { err.hidden = false; err.textContent = 'That email does not look right — check it and try again.'; }
        $('#hs-gate-email')?.classList.add('is-bad');
        return;
      }
      $('#hs-gate-email')?.classList.remove('is-bad');
      gateName = ($('#hs-gate-name')?.value || '').trim();
      sentTo = email;
      const body = new FormData(nlForm);
      fetch(nlForm.action || '/contact', { method: 'POST', body, headers: { Accept: 'application/json' } }).catch(() => {});
      showResults();
    });
    $('#hs-gate-skip')?.addEventListener('click', () => {
      gateName = ($('#hs-gate-name')?.value || '').trim();
      sentTo = '';
      showResults();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && gateEl && !gateEl.hidden) {
        gateName = ($('#hs-gate-name')?.value || '').trim();
        sentTo = '';
        showResults();
        return;
      }
      if (gateEl && !gateEl.hidden) return;
      if (step < 0 || step >= 5 || locked) return;
      const n = parseInt(e.key, 10);
      if (n >= 1 && n <= 9) pick(n - 1);
    });
    try {
      const saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (saved && Array.isArray(saved.answers) && Number.isInteger(saved.step) && saved.step >= 0 && saved.step < 5) {
        saved.answers.forEach((v, i) => { if (i < 5) answers[i] = v; });
        step = saved.step;
      }
    } catch (e) {}
    paint();
  }

  function initJournal() {
    const root = document.querySelector('[data-hs-journal]');
    if (!root) return;
    const chips = $$('[data-cat]', root);
    const cards = $$('[data-card]', root);
    const featured = $('[data-featured]', root);
    const empty = $('[data-empty]', root);
    const count = $('[data-count]', root);
    const input = $('[data-search]', root);
    let cat = 'All';
    const apply = () => {
      const q = (input?.value || '').trim().toLowerCase();
      let n = 0;
      const match = (el) => {
        const okCat = cat === 'All' || el.dataset.cat === cat;
        const okQ = !q || (el.dataset.search || '').includes(q);
        return okCat && okQ;
      };
      cards.forEach((card) => {
        const show = match(card);
        card.hidden = !show;
        if (show) n += 1;
      });
      let featOn = false;
      if (featured) {
        featOn = match(featured);
        featured.hidden = !featOn;
      }
      if (empty) empty.hidden = n > 0 || featOn;
      if (count) count.textContent = n + (n === 1 ? ' article' : ' articles');
    };
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        cat = chip.dataset.cat;
        chips.forEach((c) => c.classList.toggle('is-on', c === chip));
        apply();
      });
    });
    input?.addEventListener('input', apply);
  }

  let tocOnScroll = null;

  function initArticle() {
    const article = document.querySelector('[data-hs-article]');
    if (!article) return;
    const rte = article.querySelector('.hs-article__rte');
    if (rte) {
      rte.querySelectorAll('meta, style, xml, script').forEach((el) => el.remove());
      rte.querySelectorAll('h1').forEach((h) => h.remove());
      rte.querySelectorAll('[style]').forEach((el) => {
        if (el.matches('img')) {
          el.removeAttribute('style');
          return;
        }
        el.style.removeProperty('font-family');
        el.style.removeProperty('font-size');
        el.style.removeProperty('line-height');
        el.style.removeProperty('letter-spacing');
        el.style.removeProperty('color');
        el.style.removeProperty('margin');
        el.style.removeProperty('margin-top');
        el.style.removeProperty('margin-bottom');
        el.style.removeProperty('padding');
        if (el.matches('h1, h2, h3, h4')) el.style.removeProperty('font-weight');
        el.removeAttribute('data-mce-style');
        if (!(el.getAttribute('style') || '').trim()) el.removeAttribute('style');
      });
      rte.querySelectorAll('a').forEach((a) => {
        a.style.removeProperty('color');
        a.removeAttribute('data-mce-style');
      });
      [...rte.querySelectorAll('h2, h3, p, ul, ol, div')].forEach((el) => {
        const t = el.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        if (/^related reading/.test(t)) {
          let n = el;
          while (n) {
            const next = n.nextElementSibling;
            n.remove();
            n = next;
            if (!n) break;
            const nt = n.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
            if (/^(sources|frequently asked|the bottom line|any last)/.test(nt) || n.matches('h2')) break;
            if (n.querySelectorAll('a').length > 4 && n.textContent.length > 80) {
              n.remove();
              break;
            }
          }
        }
      });
    }
    article.querySelectorAll('.hs-article__rte h3').forEach((h) => {
      if (h.querySelector('.hs-swash')) return;
      const html = h.innerHTML;
      h.innerHTML = `<span class="msr">arrow_right</span><span class="hs-swash">${html}</span>`;
    });
    const toc = document.querySelector('[data-hs-toc]');
    if (!toc) return;
    const skip = /^(sources|any last|keep reading|side by side|related reading|frequently asked|faq|the bottom line)$/i;
    const heads = [...article.querySelectorAll('.hs-article__rte h2, .hs-listicle h2, .hs-compare-block h2, .hs-opt-card h2')].filter((h) => {
      const t = h.textContent.replace(/\s+/g, ' ').trim();
      return t && !skip.test(t);
    });
    if (!heads.length) {
      toc.closest('.hs-toc')?.classList.add('is-empty');
      return;
    }
    const used = {};
    toc.innerHTML = heads.map((h, i) => {
      let id = h.id || h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || ('section-' + (i + 1));
      if (used[id]) id = id + '-' + (i + 1);
      used[id] = true;
      h.id = id;
      const label = h.textContent.trim();
      return `<a href="#${id}">${label}</a>`;
    }).join('');
    const links = [...toc.querySelectorAll('a')];
    const syncToc = () => {
      const line = 120;
      let current = heads[0];
      for (let i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top <= line) current = heads[i];
      }
      const id = current ? current.id : '';
      links.forEach((a) => a.classList.toggle('is-on', a.getAttribute('href') === '#' + id));
    };
    if (tocOnScroll) window.removeEventListener('scroll', tocOnScroll);
    tocOnScroll = syncToc;
    window.addEventListener('scroll', syncToc, { passive: true });
    syncToc();
    article.querySelectorAll('.hs-article__rte table').forEach((table) => {
      if (table.closest('.hs-table-scroll')) return;
      const bleed = document.createElement('div');
      bleed.className = 'hs-table-bleed';
      const scroll = document.createElement('div');
      scroll.className = 'hs-table-scroll';
      table.parentNode.insertBefore(bleed, table);
      bleed.appendChild(scroll);
      scroll.appendChild(table);
    });
  }

  initJournal();
  initArticle();
  document.addEventListener('shopify:section:load', initArticle);
  document.addEventListener('shopify:section:load', () => {
    const factsEl = document.getElementById('hs-facts');
    if (factsEl) factsEl.hidden = true;
  });
})();


(() => {
  const selector = '.hs-hscroll, .hs-vp-vids';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cloneItem(item) {
    const clone = item.cloneNode(true);
    clone.dataset.hsLoopClone = 'true';
    clone.setAttribute('aria-hidden', 'true');
    clone.inert = true;
    return clone;
  }

  function setup(scroller) {
    if (scroller.closest('.hs-pdp-pairs')) return;
    const row = scroller.querySelector(':scope > .hs-hscroll__row, :scope > .hs-vp-vids__row');
    if (!row) return;
    row.querySelectorAll('[data-hs-loop-clone]').forEach((item) => item.remove());
    const originals = [...row.children];
    if (!originals.length) return;

    const styles = getComputedStyle(row);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const loopWidth = originals.reduce((width, item) => width + item.getBoundingClientRect().width, 0) + gap * originals.length;
    if (!loopWidth) return;

    for (let copies = 0; copies < 8 && row.scrollWidth < loopWidth + scroller.clientWidth * 1.5; copies++) {
      originals.forEach((item) => row.appendChild(cloneItem(item)));
    }

    scroller.classList.add('hs-auto-loop');
    let paused = false;
    let lastTime = performance.now();
    const pause = () => { paused = true; };
    const resume = () => { paused = false; lastTime = performance.now(); };
    scroller.addEventListener('mouseenter', pause);
    scroller.addEventListener('mouseleave', resume);
    scroller.addEventListener('focusin', pause);
    scroller.addEventListener('focusout', resume);
    scroller.addEventListener('pointerdown', pause, { passive: true });
    scroller.addEventListener('pointerup', resume, { passive: true });

    const tick = (time) => {
      if (!scroller.isConnected) return;
      if (!paused && !reducedMotion.matches) {
        scroller.scrollLeft += Math.min(time - lastTime, 40) * 0.018;
        if (scroller.scrollLeft >= loopWidth) scroller.scrollLeft -= loopWidth;
      }
      lastTime = time;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  function init(root = document) {
    root.querySelectorAll(selector).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();